import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Route wrapper that only allows global_admin role
 * Used for highly sensitive pages like security audit logs
 */
const GlobalAdminRoute = ({ children }) => {
  const { user, loading, role } = useAuth();

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  if (!user) {
    console.log('❌ GlobalAdminRoute: No user - redirecting to login');
    return <Navigate to="/login" replace />;
  }

  if (role !== 'global_admin') {
    console.log('❌ GlobalAdminRoute: Access denied. Role:', role, '(required: global_admin)');
    return <Navigate to="/dashboard" replace />;
  }

  console.log('✅ GlobalAdminRoute: Access granted for global_admin');
  return children;
};

export default GlobalAdminRoute;
